/* jshint esversion: 6 */

(function (aimi_mdcdot_report, $, app, undefined) {
  // Private object
  let __this = {};

  aimi_mdcdot_report.list = {
    listRow: 'dot_email__row',

    buttons: function () {
      return {
        disable: function () {
          $(__this.containerRoot)
              .find('button:not([data-dot-report-action="new-campaign"])')
              .attr('disabled', 'disabled');
        },
        enable: function () {
          $(__this.containerRoot).find('button').removeAttr('disabled');
        },
        disableRefresh: function () {
          $(__this.containerRoot).find('button[data-dot-report-action="refresh-data"]').hide();
          const key = $('[data-item="campaignDataLastUpdatedOn"]');
          key.hide();
        },
        enableRefresh: function () {
          $(__this.containerRoot).find('button[data-dot-report-action="refresh-data"]').show();
          const key = $('[data-item="campaignDataLastUpdatedOn"]');
          key.show();
        }
      }
    },
    init: async function (aimiEmailCampaignId) {
      const self = this;
      const $listContainer = $('[data-dot-reports]');
      __this.containerRoot = '.dot-reports-container';
      const $parentContainer = $(__this.containerRoot);

      self.buttons().disable();

      // Add header columns
      const $headerContainer = $('[data-campaign-header]');

      _.each(MdcDotCampaign.types(), function (type) {
        const metrics = _.template(app.templates['dot_campaign__header-col']);
        const $metrics = $(metrics(type));
        $metrics.appendTo($headerContainer);
      });

      app.initTooltip();

      $(':input[name="aimi-variants-campaign"]').select2({
        theme: 'bootstrap-5'
      });


      $parentContainer.find('.btn-sort').attr('disabled', 'disabled');

      __this.listMananger = new DotEmailVariantsList(app,$parentContainer, $listContainer, aimiEmailCampaignId, self.listRow);
      __this.listMananger.onRenderList().then(function () {
        self.buttons().enable();
      });


      $(document).off('click.campaign-sort').on("click.campaign-sort", "[data-sort]", function (e) {
        const $this = $(this);
        let sortBy = $this.data('sort');
        let sortDirection = $this.attr('data-sort-direction');
        let $sortIcons = $('[data-sort] i');
        $sortIcons.removeClass('fa-arrow-down-short-wide fa-arrow-up-short-wide').addClass('fa-arrow-up-arrow-down');
        let $i = $this.find('i');
        if (sortDirection === 'ASC') {
          $i.addClass('fa-arrow-down-short-wide');
        } else {
          $i.addClass('fa-arrow-up-short-wide');
        }

        $this.attr('data-sort-direction', sortDirection === 'ASC' ? 'DESC' : 'ASC');
        __this.listMananger = new CampaignsList(app, $listContainer, self.listRow, sortBy, sortDirection);
        return false;
      });

      $(document).off('click.select-dot-reports').on('click.select-dot-reports', '[data-dot-report-action]', async function (e) {
        const $this = $(this); // Cache the clicked element
        const action = $this.data('campaign-action'); // Extract the action from the data attribute

        // Reset UI states for mass actions and button styling
        MassActions.destroy();

        // Use a switch statement to handle different actions
        switch (action) {
          case 'refresh-data':
            try {
              // Display loading state in the stats header and button
              MdcDotCampaign.statsHeaderLoader();
              app.button($this, 'loading');

              // Fetch campaign stats sequentially
              await __this.listMananger.fetchCampaignStatsSequentially();
            } catch (error) {
              // Log any errors during the fetch process
              console.error('Error fetching data:', error);
            } finally {
              // Reset the button state after operation
              app.doButtonResetDelayed($this, false);
            }
            break;

          case 'filter':
            // Apply campaign filtering logic
            const filter = new CampaignFilter();
            filter.filter();
            break;

          default:
            // Log an unrecognized action for debugging purposes
            console.warn('Unrecognized action:', action);
            break;
        }
      });


      app.initSimpleBar($('#tab_block_2')[0]);

      // Event for instance switch
      $(document).off('submit.mdcdot_instance_user').on('submit.mdcdot_instance_user', 'form[name=mdcdot_instance_user]', function (e) {
        const $form = $(this);
      })

      $(document).off('change.mdcdot_instance_user').on('change.mdcdot_instance_user', 'form[name=mdcdot_instance_user] select', function (e) {
        const $form = $('form[name=mdcdot_instance_user]');
        $form.submit();
        return e.preventDefault();
      });

      const $chartContainer = $('.campaign-chart-container');
      __this.observerManager = new ImageObserverManager(app, '.campaign-chart', 'campaign-chart-width', $chartContainer);

      // To observe resizing for an element
      __this.observerManager.observeResize($chartContainer[0]);

      MdcDotCampaign.getHeaderColumn($headerContainer, $headerContainer);

      this.downnloadPdf();
    },

    downnloadPdf: function () {

      const getPdfName = function () {
        const instance = $('#instance').val();
        const userId = $('#user').val();

        return `${userId}-${instance}`;
      }

      document.getElementById("download").addEventListener("click", function () {
        const tabSection = document.querySelector('#tab_block_2');
        $(tabSection).addClass('pdf-preview');

        // Set PDF options
        let opt = {
          margin: 0.5,
          filename: getPdfName(),
          image: {type: 'jpeg', quality: 0.98},
          html2canvas: {scale: 2},
          jsPDF: {unit: 'in', format: [20, 30], orientation: 'portrait'}
        };

        setTimeout(function () {
          html2pdf().from(tabSection).set(opt).save().then(function () {
            $(tabSection).removeClass('pdf-preview');
          })
        }, 300);

      });

    }

  }
}(window.aimi_mdcdot_report = window.aimi_mdcdot_report || {}, jQuery, PreBuilt));

class DotReportFilter {

  static async filterCallback(response) {
    const app = PreBuilt;

    let range = response.range;
    if (!app.isEmpty(range)) {
      range = range.split(' - ');
      range = range.map(date => date.trim());
      if (!app.isEmpty(range[0])) {
        response.range = range;
      } else {
        delete response.range;
      }
    }

    NoRecordsPlaceholder.destroy();
    Toast.destroy();
    if (!app.isEmpty(app.filterModal)) {
      app.filterModal.modal('hide');
    }

    let message = [];
    const messageStatic = `Showing results for filters with `;

    if (!app.isEmpty(response.campaigns)) {
      const campaigns = response.campaigns.join(',')
      message.push(` <span class="fw-semibold"> ${campaigns}</span>`)
    }

    if (!app.isEmpty(response.q)) {
      const q = response.q;
      message.push(` <span class="fw-semibold">search ${q}</span>`)
    }

    if (!app.isEmpty(range)) {
      message.push(`<span class="fw-semibold"> date range ${range[0]} to ${range[1]} </span>`);
    }
    message = messageStatic + message.join(' and ');

    response.filter = true;
    window['searchParams'] = response;

    const $listContainer = $('[data-campaigns]');
    const listManager = new CampaignsList(app, $listContainer, 'dot_campaign__row');
    listManager.onRenderList().then(function (leadResponse) {

    });

    app.Toast = new Toast(app, $listContainer.closest('.table-campaigns'), {
      'toastClass': 'mb-5 position-sticky top-0',
      'message': message, closeButton: {
        text: 'Clear Filter',
        onClick: () => {
          Toast.destroy();
          window['searchParams'] = null;
          const listManager = new CampaignsList(app, $listContainer, 'dot_campaign__row');
          listManager.onRenderList().then(function (leadResponse) {

          });
        }
      }
    });
    app.Toast.render();
  }

  async filter() {
    const app = PreBuilt;
    const options = {
      modalDialogClass: 'modal-xl  modal-dialog-scrollable modal-dialog-centered  modal-filter-campaigns',
      template: 'dot_campaign__filter',
      title: 'Filter Campaign (Email) Statistics ',
      saveButtonText: 'Filter',
      footerText: 'Filter email statistics by date range and  campaigns',
      saveApi: '',
      saveApiCallBack: 'CampaignFilter.filterCallback',
    };

    app.inputPrompt(options).then(async function ($modal) {
      app.filterModal = $modal;
      const progress = new ProgressBar($modal.find('.container-fluid'));
      progress.start();

      const $select = $modal.find(':input[name="campaigns[]"]');

      let url = '/api/mdcdot/campaigns';
      const response = await app.apis['mdcdot'].campaign.list(url);
      const campaigns = Object.values(response.result).reverse();
      $select.closest('.campaigns-row-container').removeClass('m-progress');
      $select.attr('multiple', 'multiple');
      // Loop through the campaignsIndexById and create an option for each
      _.each(campaigns, function (campaign) {
        const $optGroup = $('<optgroup></optgroup>');
        $optGroup.attr('label', campaign.name);
        $optGroup.appendTo($select);

        const $option = $('<option></option>');
        $option.text(`Campaign - ${campaign.name}`);
        $option.attr('value', `campaign:${campaign.id}`);
        $option.appendTo($optGroup);
        _.each(campaign.sequences, function (sequence) {
          const $option = $('<option></option>');
          $option.text(`Sequence - ${sequence.name}`);
          $option.attr('value', `sequence:${sequence.id}`);
          $option.appendTo($optGroup);
        })
      });

      $select.select2({
        dropdownCssClass: 'tags-select2-dropdown',
        selectionCssClass: 'tags-select2-selection'
      });


      const $input = $modal.find('input[name=range]');
      const picker = new easepick.create({
        element: $input[0],
        zIndex: 1200,
        calendars: 3,
        grid: 3,
        plugins: [
          "RangePlugin",
          "LockPlugin",
          "PresetPlugin"
        ],
        PresetPlugin: {
          customLabels: ['Today', 'Yesterday', 'Last 7 Days', 'Last 30 Days', 'This Month', 'Last Month'],
          presets: [
            {start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date()}, // 'Last 7 Days'
            {start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date()}, // 'Last 30 Days'
            {start: new Date(new Date().getFullYear(), new Date().getMonth(), 1), end: new Date()}, // 'This Month'
            {
              start: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
              end: new Date(new Date().getFullYear(), new Date().getMonth(), 0)
            }, // 'Last Month'
          ].map((preset, index) => {
            // console.log(`Preset ${index}: Start = ${preset.start}, End = ${preset.end}`);

            // Check if start and end dates are valid instances of Date
            if (!(preset.start instanceof Date) || isNaN(preset.start.getTime())) {
              console.error(`Invalid start date for preset ${index}`);
              preset.start = new Date(); // Default to current date if invalid
            }
            if (!(preset.end instanceof Date) || isNaN(preset.end.getTime())) {
              console.error(`Invalid end date for preset ${index}`);
              preset.end = new Date(); // Default to current date if invalid
            }

            return preset;
          }),
          position: 'right',
        },
        LockPlugin: {
          minDays: 0,
          maxDays: 90,
        },
        css: ['https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'],
        inline: true
      });

      progress.remove();
    });
  }
}

// Creating a map of class references
window["DotReportFilter"] = DotReportFilter;